// Global phone number for WhatsApp and contact
export const PHONE_NUMBER = "9548921892";
export const INSTA_USERNAME = "cherryontop_jewellery";

const PRODUCT_FEATURES = ["Anti-tarnish", "Stainless Steel", "Hypoallergenic", "Everyday Elegant"];
const KOREAN_JEWELLERY_FEATURES = ["Stainless Steel", " Artificial stones", "Everyday Elegant", "Gold Plated"];
const RESIN_JEWELLERY_FEATURES = ["Base Metal- Resin", "Handmade with Love", " Made in India"]
const PRODUCT_CARE_TIPS = [
  "Wipe gently with a soft cloth after use",
  "Avoid perfumes and harsh chemicals",
  "Store in a dry box/pouch",
  "Remove when doing activity i.e working out, gardening or sleeping"
];
const RESIN_CARE_TIPS = [
  "Wipe gently with a soft cloth after use",
  "Avoid perfumes and harsh chemicals",
  " Always store your jewellery in a flat box to avoid accidental scratches",
  "Remove when doing activity i.e working out, gardening or sleeping"
]

export const antiTarnishJewelleryNecklaces = [
  {
    id: "PR7K9M2X",
    name: "2-Layer Black Square Necklace",
    price: 199,
    originalPrice: 399,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266690/1_zlqult.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266690/1_zlqult.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266691/2_tzu7mz.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266692/3_qazz6b.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266693/4_ucei4d.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M2Y",
    name: "2-Layer Crystal 💛 Necklace",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361350/1_kugult.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361350/1_kugult.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361353/2_oy5yxk.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361348/3_ds686a.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M2Z",
    name: "2-Layer Heart Snake Chain",
    price: 399,
    originalPrice: 649,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266697/1_yhbelx.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266697/1_yhbelx.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266698/2_y50h1t.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "PR7K9M3A",
    name: "3-Layer Emerald Necklace",
    price: 399,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266699/1_bozax0.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266699/1_bozax0.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266700/2_kuuc0o.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266701/3_kacoks.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266702/4_wulwm3.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3B",
    name: "Blue Whale Necklace",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266703/1_eymghn.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266703/1_eymghn.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266704/2_qn14j1.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266705/3_bwvqxa.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "PR7K9M3C",
    name: "Emerald Square Dual Chain",
    price: 425,
    originalPrice: 649,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266706/1_zdpv0d.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266706/1_zdpv0d.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266707/2_vjlsom.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266708/3_gy9ba1.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3D",
    name: "Heart Beads Chain",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266709/1_q6qgs2.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266709/1_q6qgs2.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266710/2_d3s7cl.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3E",
    name: "Heart Drop Bow Necklace",
    price: 199,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266711/1_tauqa5.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266711/1_tauqa5.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266712/2_czkn0m.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266713/3_yf5l8k.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3F",
    name: "Heart Drop Linked Chain",
    price: 425,
    originalPrice: 699,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266714/IMG_9497_bojhex.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266714/IMG_9497_bojhex.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266715/IMG_9498_vv6ox0.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "PR7K9M3G",
    name: "Hollow Heart Necklace",
    price: 249,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266716/1_n1yxkc.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266716/1_n1yxkc.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266717/2_iesbmt.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266718/3_ck1z51.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266720/4_ps5ay9.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3H",
    name: "Irregular Pearl Necklace",
    price: 199,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266721/1_jjypj6.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266721/1_jjypj6.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266722/2_an0cgt.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266725/3_l2m81o.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266727/4_x3ixje.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3I",
    name: "Magic Mirror Rose Chain",
    price: 349,
    originalPrice: 549,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266723/1_legytg.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266723/1_legytg.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266724/2_jynyum.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266726/3_kauiqr.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266728/4_njmsgd.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3J",
    name: "Reversible 🖤🤍 Lock",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361532/1_qzcinr.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361532/1_qzcinr.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361525/2_r3z70u.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361528/3_zlx89k.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361535/4_wqjcua.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361525/5_pj1yjj.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3K",
    name: "Sweetheart Necklace",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266733/1_kibksl.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266733/1_kibksl.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266734/2_ifvhfz.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266735/3_vg8mbf.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3L",
    name: "💛 Interlocked Necklace",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776364629/1_hc5exl.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776364629/1_hc5exl.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776364641/2_dsg1ql.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776364632/3_pskvcz.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776364636/4_bnk078.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3M",
    name: "🦋🌸 Zircon Necklace",
    price: 349,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361585/1_dv494k.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361585/1_dv494k.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361583/2_webwsj.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PR7K9M3N",
    name: "4-Leaf Clover",
    price: 199,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059258/4B8E7CCA-B8AA-4E57-99D6-5928AB4AE73D_tnallm.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059258/4B8E7CCA-B8AA-4E57-99D6-5928AB4AE73D_tnallm.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775486894/IMG_9014_tauxdb.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775486893/IMG_9013_hlvaz9.heic"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "PZ2L8B5T",
    name: "3-Layer Green Emerald Stone",
    price: 425,
    originalPrice: 799,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059212/FF75E6B1-1A48-4C5D-9ACF-A90FC9BBD685_rlc191.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059212/FF75E6B1-1A48-4C5D-9ACF-A90FC9BBD685_rlc191.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775486709/IMG_8953_icjdyd.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059215/IMG_8723_enpi1v.heic",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "FL3R8N5P",
    name: "Golden Rose",
    price: 199,
    originalPrice: 299,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059452/IMG_8452_gl83p2.jpg",
        carouselImages: [
        "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059452/IMG_8452_gl83p2.jpg",
        "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775489325/IMG_8946_oqib7t.heic",
        "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059453/IMG_8671_dif6t3.jpg",
      ],
      stock: 4
       },
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "BX4W2L7G",
    name: "Autumn Leaf",
    price: 299,
    originalPrice: 399,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775060002/E263379A-D35C-43DC-9D6B-6838D52C5291_xfltq2.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775060002/E263379A-D35C-43DC-9D6B-6838D52C5291_xfltq2.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059998/1335BE91-DC90-4D9D-9B4E-9F2BAE2C22CE_v7stex.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775487254/IMG_9008_et27pk.heic"
        ], 
        stock: 4 },
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "MC8V6P1Y",
    name: "Dazzling Snake",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059799/A1902826-399C-4C97-BA01-B9A316B80F25_pt4enu.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775487988/IMG_9022_ibwerd.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059780/4C9195D7-4464-4E46-AEBA-84EF2EF12D3D_zmvb7u.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059807/IMG_8766_dwp4rn.heic"
        ], 
        stock: 2 },
      { name: "Silver", hex: "#C0C0C0", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059775/1A94012B-F95B-4F3C-9D1C-A303C90E1ECA_piisr6.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059775/1A94012B-F95B-4F3C-9D1C-A303C90E1ECA_piisr6.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059785/6BFC7BF7-2FFC-4659-9CD8-5D8B436378FF_skgxwf.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059809/IMG_8771_pkc7zj.heic"
        ], 
        stock: 2 }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "NK2H9Q4R",
    name: "Crystal Small Butterfly",
    price: 249,
    originalPrice: 399,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059832/B7ECDA78-EF41-48A4-BE60-F199C0D41AB2_sg3zzp.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059832/B7ECDA78-EF41-48A4-BE60-F199C0D41AB2_sg3zzp.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059824/8ABB8B43-CAF1-4E0D-9026-5912F3C6D825_s9enmq.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775487778/IMG_9030_b8tgtn.heic"
        ], 
        stock: 2 },
      { name: "Silver", hex: "#C0C0C0", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059835/C7E45176-5C04-4945-9845-15F61E9D0E6A_dfcaru.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059835/C7E45176-5C04-4945-9845-15F61E9D0E6A_dfcaru.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059826/23D1AB3B-1D94-4D14-952F-08A0A11851C4_onmwdz.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775487814/IMG_9026_l0asxr.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "ST7J5D8K",
    name: "Crystal Cat",
    price: 299,
    originalPrice: 449,
    colors: [
      { name: "Silver", hex: "#C0C0C0", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059933/2A1F0789-5749-4225-9227-E489B37075F0_uwhfqb.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059933/2A1F0789-5749-4225-9227-E489B37075F0_uwhfqb.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059939/IMG_8781_kqt0wl.heic",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "ER9C3F6M",
    name: "Emerald Circle Minimal Necklace",
    price: 289,
    originalPrice: 399,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059749/1ADA7C5C-791B-4347-9049-723F32439D38_ctyany.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059749/1ADA7C5C-791B-4347-9049-723F32439D38_ctyany.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059754/223CCBC1-441A-431F-87B7-3269FE32DEB9_dt95v6.jpg",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "ZW5L2T9B",
    name: "Emerald Triangle Minimal Necklace",
    price: 289,
    originalPrice: 399,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059585/7548BDE7-1F17-4D57-84B4-086B7A6A9D22_bg8acg.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059585/7548BDE7-1F17-4D57-84B4-086B7A6A9D22_bg8acg.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059583/72D412A3-D3C3-433E-9D3C-30A5548F1CBF_ctuvwe.jpg",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "CJ8P4S7K",
    name: "Crystal Butterfly",
    price: 309,
    originalPrice: 499,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059960/8D4AE989-FBCE-4697-922D-B7850C12FE6E_mho0mm.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059960/8D4AE989-FBCE-4697-922D-B7850C12FE6E_mho0mm.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059969/IMG_8774_suavui.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775487370/IMG_9039_ayzflh.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "OA1N6V2L",
    name: "Crystal Dolphin Tail",
    price: 309,
    originalPrice: 499,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059907/79567410-B295-4624-9E5A-FF7AC8CC77EE_dar3yq.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059907/79567410-B295-4624-9E5A-FF7AC8CC77EE_dar3yq.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775487610/IMG_9032_cicwyy.heic",
        ], 
        stock: 2 },
      { name: "Silver", hex: "#C0C0C0", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059902/62824ADE-2F51-43F9-A2DC-90898E419F0C_ekkm3k.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059902/62824ADE-2F51-43F9-A2DC-90898E419F0C_ekkm3k.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059914/F2E14621-D973-4E76-B661-A24132A9A8E5_sgfdym.jpg",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "UH7M3K9X",
    name: "Emerald Royal Pink Stone",
    price: 325,
    originalPrice: 599,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059642/06AA99B3-5A1C-4AC9-A1FE-AAAE4B0F1119_bp3f7v.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059647/45799F7C-EAD8-4F8C-856E-1A5250B04891_hoadui.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775488899/IMG_8967_domwo2.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059656/IMG_8706_qczpbf.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "QE4F8R5P",
    name: "Emerald Royal Purple Stone",
    price: 325,
    originalPrice: 599,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059610/70BD8329-65B5-4E25-90E6-D309919C49CC_dna42n.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059610/70BD8329-65B5-4E25-90E6-D309919C49CC_dna42n.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775489056/IMG_8971_o6okva.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059618/IMG_8707_wujl8j.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "YT6L2W9G",
    name: "Emerald Royal Blue Stone",
    price: 325,
    originalPrice: 599,
    colors: [
      {  name: "Silver", hex: "#C0C0C0", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059682/735D9FD5-EC82-4B08-9078-CDD0527BA09F_emrehg.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059682/735D9FD5-EC82-4B08-9078-CDD0527BA09F_emrehg.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775488639/IMG_8968_jiumh5.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059679/32F52F2E-D000-4555-A0F8-51FEE726333D_zmwss3.jpg",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "IK9J3D7C",
    name: "Crystal Leaf",
    price: 299,
    originalPrice: 399,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059861/5AB65554-327E-4859-B77A-7689DA2B24B6_foo3ay.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059861/5AB65554-327E-4859-B77A-7689DA2B24B6_foo3ay.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059866/4937B22B-6B4B-4DAD-B901-D96A3E939782_zbdddm.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059869/IMG_8779_r24y4e.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "LS8V5H2J",
    name: "Pearl Finish Crystal Heart",
    price: 289,
    originalPrice: 399,
    colors: [
      { name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059483/IMG_8761_lqdb0z.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775489478/IMG_9037_witxfu.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059485/IMG_8764_zqsouy.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059483/IMG_8761_lqdb0z.heic",
        ], 
        stock: 2 },
      { name: "Silver", hex: "#C0C0C0", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059482/23A85027-A936-4FE0-BAFC-DE70827B09E5_f07lxp.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059482/23A85027-A936-4FE0-BAFC-DE70827B09E5_f07lxp.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059485/IMG_8764_zqsouy.heic",
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "MX4P7R1S",
    name: "Gold Plated Oval Shape Necklace",
    price: 299,
    originalPrice: 499,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059564/D7E32C87-AD70-43E0-926E-6271796991B4_fzj3ku.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059564/D7E32C87-AD70-43E0-926E-6271796991B4_fzj3ku.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775489180/IMG_8940_fupftd.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775489179/IMG_8930_xv1oxs.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "GF6C9K3W",
    name: "Emerald Royal Light Blue Stone",
    price: 349,
    originalPrice: 549,
    colors: [
      {  name: "Gold", hex: "#D4AF37", image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059715/53EB55B6-6CF8-416B-9C98-B971A225B693_xffpg4.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775488427/IMG_8939_ib1v5j.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775488427/IMG_8937_onhoo7.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1775059721/IMG_8705_zdbbcd.heic"
        ], 
        stock: 2  }
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  
];

export const tulipBracelets = [
  {
    id: "TB2D7M5R",
    name: "Cinderella",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266887/1_b5qg8g.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266887/1_b5qg8g.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266885/2_hdeug0.heic",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "TB3E6N7S",
    name: "Disney Rapunzel",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266888/1_gold_hhmzzq.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266888/1_gold_hhmzzq.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266891/IMG_9872_zvtrfa.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266889/IMG_9159_uquxfk.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "TB4F5P8T",
    name: "Princess Anna",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266892/IMG_9160_emwusu.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266892/IMG_9160_emwusu.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266893/IMG_9368_nxsd7g.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "TB5G4Q9U",
    name: "Princess Ariel",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266894/IMG_9743_sinxdk.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266894/IMG_9743_sinxdk.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266910/IMG_9754_ixwp7c.heic",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "TB6H3R2V",
    name: "Princess Aurora",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266898/IMG_9351_ckomcy.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266898/IMG_9351_ckomcy.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266897/2_w2owri.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266896/1_silver_p06njp.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "TB7J2S3W",
    name: "Princess Belle",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266901/1_w4d3ac.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266901/1_w4d3ac.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266902/2_txx0bt.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266904/IMG_9745_eyw5wk.heic"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "RR1K8T4X",
    name: "Snow White",
    price: 399,
    originalPrice: 599,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266905/1_la3k1m.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266905/1_la3k1m.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266906/2_gnn9xw.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266908/3_pxuwcx.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]

export const resinJewelleryRings = [
  {
    id: "RR2L7U5Y",
    name: "Blue Plum Ring",
    price: 190,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266857/1_dbfz25.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266857/1_dbfz25.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266861/2_tow62m.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "RR3M6V7Z",
    name: "Rectangular Floral Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266869/1_szfyq3.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266869/1_szfyq3.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266870/2_ko9z8b.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "KN1N5W8A",
    name: "White Floral Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266871/1_kqimmy.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266871/1_kqimmy.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266872/2_em6n8g.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "KN1N5W8B",
    name: "Daisy 🌼 Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361084/1_ttaeeg.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361084/1_ttaeeg.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361086/2_rifqx0.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361083/3_fvgvt1.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "KN1N5W8C",
    name: "Oval Shape 🌸 Plum Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361112/1_frragc.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361112/1_frragc.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361114/2_hl3ntl.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361110/3_tr7ofi.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "KN1N5W8D",
    name: "Pink🌸 Heart Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361140/IMG_9311_ljx4v6.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361140/IMG_9311_ljx4v6.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361138/IMG_9317_dztohn.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361142/IMG_9312_vopvzp.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "KN1N5W8E",
    name: "🌼🌸 Plum Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361175/IMG_9314_svqxbu.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361175/IMG_9314_svqxbu.jpg",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
  {
    id: "KN1N5W8F",
    name: "💜 Plum Ring",
    price: 190,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776363065/IMG_9814_y1xrqh.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776363065/IMG_9814_y1xrqh.heic",
        ], 
        stock: 2 },
        
    ],
    features: RESIN_JEWELLERY_FEATURES,
    careTips: RESIN_CARE_TIPS
  },
]

export const koreanJewelleryNecklaces = [
  {
    id: "KN2P4X9B",
    name: "2-Layer Pearl & 🤍 Chain",
    price: 145,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360868/1_hwpqop.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360868/1_hwpqop.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360867/2_n1c2rm.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360866/3_rj44ka.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KN2P4X9C",
    name: "2-Layer 🦋 Butterfly Necklace",
    price: 175,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360911/1_qb288y.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360911/1_qb288y.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360914/2_si2dyq.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360913/3_llkqdv.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360915/4_ojx2js.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360917/5_uphaxx.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360910/6_kzweky.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KN2P4X9D",
    name: "Crystal 💖 Asymmetric Necklace",
    price: 160,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360959/1_mrkx66.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360959/1_mrkx66.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360961/2_yf5dyq.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360962/3_in8ypg.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360964/4_z2ikao.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360958/5_ung6ln.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KN2P4X9E",
    name: "Moon & Star Dual Chain",
    price: 140,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360996/1_tpg6o4.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360996/1_tpg6o4.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360998/2_wxq6bl.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361000/3_qv0pln.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360995/4_ejoulp.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KN2P4X9F",
    name: "Pink Heart 🎀 Necklace",
    price: 140,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361035/1_exhvbr.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361035/1_exhvbr.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361037/2_egwnh7.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776361033/3_bikf9m.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KN2P4X9G",
    name: "Butterfly Layered Chain",
    price: 135,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266825/1_slx6gv.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266825/1_slx6gv.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266824/2_yuw6zi.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266827/3_is74l4.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KN3Q3Y2C",
    name: "Cherry Necklace",
    price: 140,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266828/1_rfkm9q.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266828/1_rfkm9q.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266829/2_nbuxdv.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266830/3_sjlntt.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE1R8Z4D",
    name: "Hollow Heart Stone Necklace",
    price: 135,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266837/1_evgkvy.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266837/1_evgkvy.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266838/2_wlqdye.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]

export const koreanJewelleryEarrings = [
  {
    id: "KE2S7A5F",
    name: "Bow Knot In 🤍",
    price: 120,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360605/1_rmnnnm.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360605/1_rmnnnm.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360605/IMG_9772_scuvro.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE2S7A5H",
    name: "M&G Oval Shape",
    price: 95,
    originalPrice: 149,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360640/1_ynduwo.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360640/1_ynduwo.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360641/IMG_9777_dnrfbv.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE2S7A5I",
    name: "Multi-🩷 Chains Earrings",
    price: 120,
    originalPrice: 249,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360698/1_rsznbf.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360698/1_rsznbf.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360699/2_q4va6l.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360699/3_tzc6wx.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE2S7A5J",
    name: "Pink Crystal 💖",
    price: 110,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360725/1_hst1tb.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360725/1_hst1tb.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360726/2_zl3lho.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360725/3_qsvu5z.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE2S7A5K",
    name: "Rhinestone 🍒 Earrings",
    price: 110,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776362135/1_rxj4hr.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776362135/1_rxj4hr.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776362138/2_enemb1.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776362133/3_wyawub.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE2S7A5L",
    name: "White Enamel 🤍 Studs",
    price: 90,
    originalPrice: 149,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360801/1_x3v9gu.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360801/1_x3v9gu.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360802/2_qqyah7.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776360800/3_mrqx4w.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE2S7A5E",
    name: "Floral Hoops",
    price: 115,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266770/1_zxt4en.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266770/1_zxt4en.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266771/2_nxbb3p.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266773/3_klaaa3.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE3T6B7F",
    name: "Golden Water-Droplet Earrings",
    price: 110,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266774/1_r0nrxy.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266774/1_r0nrxy.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266775/2_kguptr.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE4U5C8G",
    name: "Heart Hoops",
    price: 115,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266776/1_trrlnk.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266776/1_trrlnk.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266777/2_tb9fze.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE5V4D9H",
    name: "Mismatch Waterdrop Earrings",
    price: 120,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266780/1_c2ak7a.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266780/1_c2ak7a.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266781/2_fo44nh.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266782/3_wckgas.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE6W3E2J",
    name: "Moonstone Earrings",
    price: 110,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266784/1_ezj268.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266784/1_ezj268.heic",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266785/IMG_9763_soppmb.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "KE7X2F3K",
    name: "Rotational Texture Earrings",
    price: 95,
    originalPrice: 199,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266795/1_fnrxgn.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266795/1_fnrxgn.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266796/2_va6vp4.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266797/3_shty4t.jpg"
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AE1Y8G4L",
    name: "Twisted Gold Hoops",
    price: 95,
    originalPrice: 149,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266798/IMG_9418_c5rsmc.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266798/IMG_9418_c5rsmc.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]

export const antiTarnishEarrings = [
  {
    id: "AE2Z7H5M",
    name: "Hollow Heart Earrings",
    price: 199,
    originalPrice: 349,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266663/1_tmaiht.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266663/1_tmaiht.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266665/2_cxwyzk.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266664/3_balfs1.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AE3A6J7N",
    name: "Coquette 🧡 Bow Earrings",
    price: 279,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270483/1_sgtibb.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270483/1_sgtibb.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270484/2_odebjf.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270495/3_pu9k0q.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AB1B5K8P",
    name: "Bubble 💛 Studs",
    price: 199,
    originalPrice: 349,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270129/1_kaweb8.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270129/1_kaweb8.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270130/2_ejypn3.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270132/3_evqhqv.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776270135/4_kuzemc.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]

export const antiTarnishBracelets = [
  {
    id: "AB2C4L9Q",
    name: "Love 🫶🏻 Chain Bracelet",
    price: 299,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266490/1_xd1fac.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266490/1_xd1fac.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266491/2_dbevrp.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266490/3_vhdwal.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AB3D3M2R",
    name: "Evil Eyes Bracelet",
    price: 325,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266383/1_gzvxxs.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266383/1_gzvxxs.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266383/2_dejgn5.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266384/3_qq7epc.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AB4E2N3S",
    name: "Green Emerald Gemstone",
    price: 325,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266394/1_cdpbzl.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266394/1_cdpbzl.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266395/2_obnyvo.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266395/3_cbwmlr.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AR1F8P4T",
    name: "Mother Of Pearl",
    price: 325,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266396/1_irgalv.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266396/1_irgalv.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266396/2_rembpi.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266396/3_pewzr6.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266397/4_djzsrr.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]

export const antiTarnishRings = [
  {
    id: "AR2G7Q5U",
    name: "Hawthorn",
    price: 150,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266593/1_e1nvh7.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266593/1_e1nvh7.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AR3H6R7V",
    name: "Hollow Leaf",
    price: 150,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266594/IMG_9889_tjtnlm.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266594/IMG_9889_tjtnlm.jpg",
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AR4J5S8W",
    name: "Rowan",
    price: 150,
    originalPrice: 299,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266594/1_em3n3n.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266594/1_em3n3n.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266595/2_pfervj.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266596/IMG_9888_wjuhxi.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "AR5K4T9X",
    name: "Sunflower Rotating Ring",
    price: 249,
    originalPrice: 499,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266597/1_mc2vet.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266597/1_mc2vet.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266598/2_oruljq.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266598/3_ulh78v.jpg",
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776266599/4_pqctlp.jpg"
        ], 
        stock: 2 },
        
    ],
    features: PRODUCT_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]

export const enamelJewellery = [
    {
  id: "EN1A8G4L",
    name: "White Daisy Earrings",
    price: 60,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441569/White_daisy_earrings_b9hhkw.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441569/White_daisy_earrings_b9hhkw.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EN2B7H5M",
    name: "Yellow Daisy Earrings",
    price: 60,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441568/Yellow_daisy_earrings_mbwbgl.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441568/Yellow_daisy_earrings_mbwbgl.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "EN3C6J7N",
    name: "Yellow Daisy Chain",
    price: 80,
    originalPrice: 129,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441568/Yellow_daisy_chain_o4fy8y.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441568/Yellow_daisy_chain_o4fy8y.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EN4D5K8P",
    name: "Cloud Earrings",
    price: 50,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Cloud_earrings_yg5csy.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Cloud_earrings_yg5csy.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "EN5E4L9Q",
    name: "Evil Eye Chain",
    price: 80,
    originalPrice: 149,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Evil_eye_chain_judie7.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Evil_eye_chain_judie7.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EN6F3M2R",
    name: "Red Butterfly Chain",
    price: 60,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441568/Red_butterfly_chain_pppvue.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441568/Red_butterfly_chain_pppvue.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EN7G2N3S",
    name: "Evil Eye Earrings",
    price: 60,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Evil_eye_earrings_qgsfxc.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Evil_eye_earrings_qgsfxc.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "EN8H1P4T",
    name: "White Daisy Chain",
    price: 80,
    originalPrice: 149,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/White_daisy_chain_feo6ug.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/White_daisy_chain_feo6ug.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "EN9J8Q5U",
    name: "Rainbow 3 Earrings",
    price: 50,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Rainbow-3_earrings_hec1tj.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441567/Rainbow-3_earrings_hec1tj.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EM1K7R6V",
    name: "Rainbow 4 Earrings",
    price: 50,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441564/Rainbow-4_earrings_feqf8s.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441564/Rainbow-4_earrings_feqf8s.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EM2L6S7W",
    name: "Rainbow 5 Earrings",
    price: 50,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441566/Rainbow-5_earrings_snqmtv.heic", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441566/Rainbow-5_earrings_snqmtv.heic",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EM3M5T8X",
    name: "Cloud Face Rainbow Earrings",
    price: 50,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441566/Cloud_face_rainbow_earrings_kszzsc.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441566/Cloud_face_rainbow_earrings_kszzsc.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EM4N4U9Y",
    name: "Murakami flower chain",
    price: 60,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441566/Murakami_flower_chain_aemrue.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441566/Murakami_flower_chain_aemrue.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
  {
    id: "EM5P3V2Z",
    name: "Best Friend chain",
    price: 99,
    originalPrice: 149,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441565/Best_friends_chain_set_of_2_bvlsrh.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441565/Best_friends_chain_set_of_2_bvlsrh.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
   {
    id: "EM6Q2W3A",
    name: "Baby Pink Butterfly Chain",
    price: 60,
    originalPrice: 99,
    colors: [
      { name: "Gold", 
        hex: "#D4AF37", 
        image: "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441565/Baby_pink_butterfly_jpvx7d.jpg", 
        carouselImages: [
          "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_500,h_500/v1776441565/Baby_pink_butterfly_jpvx7d.jpg",
        ], 
        stock: 2 },
        
    ],
    features: KOREAN_JEWELLERY_FEATURES,
    careTips: PRODUCT_CARE_TIPS
  },
]
export const allJewellery = [
  ...antiTarnishJewelleryNecklaces,
  ...tulipBracelets,
  ...resinJewelleryRings,
  ...koreanJewelleryNecklaces,
  ...koreanJewelleryEarrings,
  ...antiTarnishEarrings,
  ...antiTarnishBracelets,
  ...antiTarnishRings,
  ...enamelJewellery
]
export const mostLovedproducts = ["FL3R8N5P", "AE3A6J7N", "AR1F8P4T", "AR5K4T9X", "PR7K9M3K","KN2P4X9C","BX4W2L7G","PR7K9M3A","KE2S7A5F"]
  .map((id) => allJewellery.find((p) => p.id === id))
  .filter(Boolean);

export const whatsHotRightNow = tulipBracelets;

export const youCannotMissThis = ["PR7K9M3M","PR7K9M3B","KE2S7A5E","PR7K9M3F","PR7K9M3I","KN2P4X9E","PR7K9M3J"]
  .map((id) => allJewellery.find((p) => p.id === id))
  .filter(Boolean);

export const allAntiTarnishJewellery = [
  ...antiTarnishJewelleryNecklaces,
  ...antiTarnishEarrings,
  ...antiTarnishBracelets,
  ...antiTarnishRings
]

export const allKoreanJewellery = [
  ...koreanJewelleryNecklaces,
  ...koreanJewelleryEarrings,
]

export const allResinJewellery = [
  ...resinJewelleryRings
]

 export const sampleGramVideos = [
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579580/1_u8oezd.mov",
      caption: "Under ₹500"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579577/2_rfpmwa.mp4",
      caption: "Close-up"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579576/3_ikcre4.mov",
      caption: "How we make it"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579577/4_lifman.mov",
      caption: "Under ₹500"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579578/5_ubwzkg.mov",
      caption: "Close-up"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579578/6_fyior3.mp4",
      caption: "How we make it"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579741/7_pwsoii.mp4",
      caption: "Close-up"
    },
    {
      src: "https://res.cloudinary.com/drgfv3nhj/video/upload/v1775579707/8_j4lm8n.mov",
      caption: "How we make it"
    }
  ];

  export const HERO_IMAGES = [
    "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_1400,h_700/v1775059513/IMG_8739_uvfe0q.heic",
    "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_1400,h_700/v1775059510/IMG_8701_erbdjz.heic",
    "https://res.cloudinary.com/drgfv3nhj/image/upload/f_auto,q_auto,c_fill,w_1400,h_700/v1775059525/IMG_8791_inuwwv.heic"
  ];
